module.exports = __webpack_public_path__ + "static/media/carbon_carousel-horizontal.cba3be02.svg";